/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RmaShipmentDto { 
    shippedAt: string;
    option: RmaShipmentDto.OptionEnum;
    shippedBy: string;
    trackingId?: string;
}
export namespace RmaShipmentDto {
    export const OptionEnum = {
        Dhl: 'DHL',
        Ups: 'UPS',
        FedEx: 'FED_EX',
        Tnt: 'TNT',
        KuehneNagel: 'KUEHNE_NAGEL',
        DbSchenker: 'DB_SCHENKER',
        CollectedByCustomer: 'COLLECTED_BY_CUSTOMER',
        Other: 'OTHER'
    } as const;
    export type OptionEnum = typeof OptionEnum[keyof typeof OptionEnum];
}


